import { useTrackAiInsightsEvent } from '../../shared';
import { type DiagnosticsAnalyticsEventProperties } from '../DiagnosticsAnalyticsEvents';

const useTrackDiagnosticsEvent = () => useTrackAiInsightsEvent<DiagnosticsAnalyticsEventProperties>();

export default useTrackDiagnosticsEvent;
